// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qrUrl, .totpCode {
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-bottom: 10px; /* Optional spacing between divs */
  word-break: break-all;
}`, "",{"version":3,"sources":["webpack://./src/app/totp-setup/totp-setup.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA,EAAA,kCAAA;EACA,qBAAA;AACF","sourcesContent":[".qrUrl, .totpCode {\n  width: 100%;\n  padding: 20px;\n  text-align: center;\n  margin-bottom: 10px; /* Optional spacing between divs */\n  word-break: break-all;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
